const logotext = "ddb.dev()";
const meta = {
  title: "Danilo Di Bella",
  description:
    "Danilo Di Bella, back-end developer, programming enthusiast, Italy based. ",
};

const introdata = {
  title: "I’m Danilo Di Bella",
  animated: {
    first: "I love coding",
    second: "Java Back-End Developer",
    third: "Programming enthusiast",
    fourth: "Always learning",
    fifth: "Based in Italy",
  },
  description: "Programmer based in Italy with a passion for knowledge",
  your_img_url: "https://i.imgur.com/Nrrv2f9.png",
};

const dataabout = {
  title: "About my self",
  aboutme:
    "I graduated in 2016 from an IT-focused technical institute, and ever since then, I've been eager to learn more about programming and developing. In 2019, I joined a web agency where I worked on a variety of projects, from the PSD conversion to HTML  for a famous hotel in North Italy's (including booking functions using jQuery) to creating a management system in PHP for the local port. These projects gave me a clear understanding of how front-end and back-end work together.Following that experience, I made the decision to move forward with something that met my expectations. I pursued a Java course offered by CGM Consulting SRL in June 2022, which helped me solidify my knowledge of the language's foundations before enrolling in an advanced course on the Spring Framework and Microservices. Now I'm currently working as a consultant for Concept Reply on behalf of CGM Consulting SRL on an automotive project for one of the largest company in the world.",
};
const worktimeline = [
  {
    jobtitle: "Back-end Developer - Concept Reply",
    where: "Turin - Italy",
    date: "2023 - now",
  },
  {
    jobtitle: "IT Consultant - CGM Consulting",
    where: "Turin - Italy",
    date: "2023 - now",
  },
  {
    jobtitle: "CGM Advanced Course - Spring Boot and Microservices",
    where: "Trapani - Italy",
    date: "2022",
  },
  {
    jobtitle: "CGM Base Course - Fundamentals of Java",
    where: "Trapani - Italy",
    date: "2022",
  },

  {
    jobtitle: "Civil service",
    where: "Trapani - Italy",
    date: "2020 - 2021",
  },
  {
    jobtitle: "Consulant in Web Agency",
    where: "Trapani - Italy",
    date: "2019",
  },
];

const skills = [
  {
    name: "JavaEE",
    value: 60,
  },
  {
    name: "AWS",
    value: 40,
  },
  {
    name: "Spring Framework",
    value: 80,
  },
  {
    name: "Spring Cloud",
    value: 60,
  },
  {
    name: "Java",
    value: 80,
  },
  {
    name: "RDBMS",
    value: 80,
  },
  {
    name: "PHP",
    value: 60,
  },
  {
    name: "Javascript",
    value: 40,
  },
  {
    name: "React",
    value: 50,
  },
];

const services = [
  {
    title: "Java Back-End Developer",
    description: "Developing web-application with Spring Boot framework.",
  },
  {
    title: "Amazon Web Service",
    description: "Experience with the AWS infrastructure.",
  },
  {
    title: "Microservices",
    description:
      "From monolithic application to microservices using Spring cloud.",
  },
  {
    title: "Secure RESTful Web Services",
    description: "CRUD operations with also the security of endpoints.",
  },
  {
    title: "Database building architecture",
    description: "From a ER diagram to a concrete database.",
  },
];

const certifications = [
  {
    title: "Executive Business Communication Skills - CEFR B2",
    organization: "Shenker",
    date: "November 2023",
    description: "Mastered advanced executive communication: refined writing, dynamic presentations, and effective negotiations in international business contexts, achieving CEFR B2 proficiency.",
  },
  // Add more certification objects as needed
];

const dataportfolio = [
  {
    title: "Ticket System",
    img: "spring",
    desctiption:
      "The basic idea behind this project was to build a simple help-desk ticket system API developed in the language i'm currently studying, Java, more precisely using the framework Spring.",
    link: "https://github.com/ddbdev/Ticket-System-Spring-Boot",
  },
  {
    title: "Blog Back-End",
    img: "spring",
    desctiption:
      "Beta project of a blog with JWT authentication, role and permission management.",
    link: "https://github.com/ddbdev/Blog",
  },
  {
    title: "Blog Front-End (React)",
    img: "react",
    desctiption: "Front end part in React of the Blog previously mentioned.",
    link: "https://github.com/ddbdev/React-Blog",
  },
  {
    title: "Authentication System",
    img: "spring",
    desctiption:
      "Login and registration system with JWT Authentication, role and permission handling.",
    link: "https://github.com/ddbdev/Login_JWT",
  },
];

const contactConfig = {
  YOUR_EMAIL: "dibelladanilo32@gmail.com",
  YOUR_FONE: "-",
  description:
    "Contact me via email for more information or check out my linkedin. ",
  // creat an emailjs.com account
  // check out this tutorial https://www.emailjs.com/docs/examples/reactjs/
  YOUR_SERVICE_ID: "service_coi1nhr",
  YOUR_TEMPLATE_ID: "template_pfgqz6m",
  YOUR_USER_ID: "hKrUdak6NvAuQ89z_",
};

const socialprofils = {
  github: "https://github.com/ddbdev/",
  facebook: "https://www.facebook.com/dani.dafuq/",
  linkedin: "https://www.linkedin.com/in/danilo-di-bella-7ab682125/",
};
export {
  meta,
  dataabout,
  dataportfolio,
  worktimeline,
  skills,
  services,
  introdata,
  contactConfig,
  socialprofils,
  logotext,
  certifications,
};
